import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { ISeason } from 'src/seasons'
import { ILanguage } from 'src/i18n'
import { I18nextContext } from 'gatsby-plugin-react-i18next'
import {
  extractBasicLaws,
  getVolumesBySeasonAndLocale,
  mapLawsToMenuStructure,
} from 'src/helpers/laws'
import lawsStore from 'src/components/laws/laws-store'

const GUIDELINES_SLUG = 'practical-guidelines-for-match-officials'

const useLawsMenuStructure = () => {
  const lngContext = React.useContext(I18nextContext)

  const selectedSeason = lawsStore((state) => state.selectedSeason)

  const data = useStaticQuery(graphql`
    query {
      allLaws {
        nodes {
          locale
          season {
            slug
            year
            id
          }
          volumes {
            slug
            sortOrder
            title
            type
            id
            chapters {
              header
              title
              displays {
                slug
                volumeId
                lawVersionId
              }
              sections {
                slug
                lawSectionCategoryName
                sectionIndex: lawSectionCategoryNumeral
              }
            }
          }
        }
      }
    }
  `)

  const getGuidelinesBySeasonAndLocale = (
    locale: ILanguage['code'],
    season: ISeason['year']
  ) =>
    extractBasicLaws(
      getVolumesBySeasonAndLocale(locale, season, data.allLaws.nodes),
      GUIDELINES_SLUG
    )

  const basicLawsVolume = getGuidelinesBySeasonAndLocale(
    lngContext.language,
    selectedSeason.year
  )

  return mapLawsToMenuStructure(
    basicLawsVolume,
    selectedSeason,
    GUIDELINES_SLUG,
    'guidelines/'
  )
}

export default useLawsMenuStructure
